






























// @ts-nocheck
// ^^^^^^^^^^^ Disabled TypeScript linter in this file because it doesn't understand Vue components
// which is not wrapped in Vue.extend(), and we can't use Vue.extend() in Sanity serializers
// because of how src/components/SanityBlockContent.vue initializes the serializers.

import { vueVimeoPlayer } from 'vue-vimeo-player';
import { calculatePlayerSize } from '@/utils/playerSize';

export default {
  name: 'SanityVimeoSerializer',
  components: {
    vueVimeoPlayer,
  },
  props: {
    url: String,
    title: String,
    description: String,
    color: {
      type: String,
      default: () => 'black',
    },
    showGutter: Boolean,
  },
  data() {
    return {
      videoId: '',
      playerSize: { width: 720, height: 720 / 1.78 },
    };
  },
  created() {
    this.setPlayerSize();
    this.videoId = this.extractVideoId(this.url);
  },
  watch: {
    $windowWidth() {
      this.setPlayerSize();
    },
  },
  methods: {
    setPlayerSize() {
      const playerSize = calculatePlayerSize(this.$windowWidth);
      this.playerSize = {
        width: playerSize.width,
        height: playerSize.height,
      };
    },
    extractVideoId(url: string): string {
      return url.substring(url.lastIndexOf('/') + 1, url.length);
    },
  },
};
